// extracted by css-extract-rspack-plugin
export default {"qrRow":"ChinaDownloadQRs-module__qrRow","qrItem":"ChinaDownloadQRs-module__qrItem","qrLabel":"ChinaDownloadQRs-module__qrLabel","qrImg":"ChinaDownloadQRs-module__qrImg"};